import React from 'react';
import * as PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBars, faTimes } from '@fortawesome/pro-regular-svg-icons';
import { getCustomerSelector } from 'common/selectors';
import { useSelector } from 'react-redux';
import { translateForCustomer } from 'utils/i18n';
import { useTranslation } from 'react-i18next';

export const HamburgerMenu = ({ onClick, menuOpen }) => {
  const { t } = useTranslation();

  const customer = useSelector(getCustomerSelector);

  return (
    <button
      data-e2e="ct-hamburger-menu"
      className={`ct-hamburger-menu${menuOpen ? ' ct-hamburger-menu--close' : ''}`}
      onClick={onClick}
      aria-expanded={menuOpen}
      aria-label={t('menu')}
      aria-controls="ct-navigation-mobile"
    >
      <div className={`ct-hamburger-menu__icons${menuOpen ? ' ct-hamburger-menu__icons--close' : ''}`}>
        {!menuOpen ? <FontAwesomeIcon icon={faBars} /> : <FontAwesomeIcon icon={faTimes} />}
      </div>
      <span className={`ct-hamburger-menu__label${menuOpen ? ' ct-hamburger-menu__label--close' : ''}`}>
        {translateForCustomer('mobile-page.navigation.menu.label', customer)}
      </span>
    </button>
  );
};

HamburgerMenu.propTypes = {
  onClick: PropTypes.func.isRequired,
};
